/** Verbeterregister + sleuteloverzicht — API-laag (/Api/verbeterregister, /Api/sleutels). */
import { BACKEND_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

export async function vraag(pad, opties = {}) {
  const r = await authFetch(`${BACKEND_URL}${pad}`, {
    ...opties,
    headers: { 'Content-Type': 'application/json', ...(opties.headers || {}) },
    body: opties.body !== undefined ? JSON.stringify(opties.body) : undefined,
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const fout = new Error(typeof d.detail === 'string' ? d.detail : (d.error || `Fout ${r.status}`));
    fout.status = r.status;
    throw fout;
  }
  return d;
}

export const verbeterApi = {
  lijst: (vers = false) => vraag(`/Api/verbeterregister${vers ? '?vers=1' : ''}`),
  projecten: (q) => vraag(`/Api/verbeterregister/projecten?q=${encodeURIComponent(q)}`),
  nieuw: (body) => vraag('/Api/verbeterregister', { method: 'POST', body }),
  wijzig: (id, body) => vraag(`/Api/verbeterregister/${id}`, { method: 'PATCH', body }),
};
